/* eslint-disable import/no-duplicates */
// @ts-ignore
import WinBox from 'winbox/src/js/winbox';
import APIV5 from '~/models/api';
import WinboxType from 'winbox';
import 'winbox/dist/css/winbox.min.css';
import { ResetModel } from '~/scripts/services/model/reset';
import { HomeLayoutService as HomeLayoutServiceType } from '~/pages/home/home-layout.service';
import { UserModel } from '~/scripts/services/model/user';
import { useRecorder } from '~/scripts/services/recorder/recorder';

/* globals Knitiv */

export default class HeaderController {
	#User;

	/** @type {ResetModel} */
	#Reset;

	/** @type {Knitiv.RootScope} */
	#$rootScope;

	/** @type {HomeLayoutServiceType} */
	HomeLayoutService;

	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ILocationService} $location
	 * @param {UserModel} User
	 * @param {ResetModel} Reset
	 * @param {any} HomeLayoutService
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor(
		/** @type {Knitiv.RootScope} */ $rootScope,
		$location,
		User,
		Reset,
		HomeLayoutService,
		$timeout,
	) {
		this.#$rootScope = $rootScope;
		this.#Reset = Reset;
		this.#User = User;
		this.aktivnote = undefined;
		this.dev = process.env.NODE_ENV !== 'production';
		this.HomeLayoutService = HomeLayoutService;
		this.$timeout = $timeout;
		this.$location = $location;

		this.recorder = useRecorder();

		$rootScope.$watch('appConfig', () => {
			/** @type {Knitiv.AppConfigTheme} */
			const theme = $rootScope.appConfig?.theme ?? {};
			if (theme) {
				const logo = theme.logo ?? '';
				this.cssLogo = {
					'background-image': `url(${logo})`,
				};
			}
			this.aktivnote = $rootScope.appConfig?.config?.AKN;
		});
	}

	/**
	 * @param {string} viewLocation
	 * @returns {boolean} Is active?
	 */
	isActive(viewLocation) {
		return viewLocation === this.$location.path();
	}

	// eslint-disable-next-line class-methods-use-this
	isDev() {
		return process.env.NODE_ENV !== 'production';
	}

	/**
	 * force logout event in API failure
	 *  @returns {Promise<any>} Promise result
	 */
	async logout() {
		await APIV5.instance.logout({ id: 'header-logout' });
		this.#User.logout('LOGOUT_USER');
	}

	hasRoleKNote() {
		const roles = this.#$rootScope.context?.role?.role
			? Object.keys(this.#$rootScope.context.role.role) : [];
		return roles.includes('K_NODE;KR_ADMIN_KNOTE') || roles.includes('K_NODE;KR_USER_KNOTE');
	}

	isAdmin() {
		return this.#$rootScope.context?.profil?.admin === 1 ?? false;
	}

	toggleMemoryStats() {
		this.#$rootScope.displayMemoryStats = !this.#$rootScope.displayMemoryStats;
	}

	// eslint-disable-next-line class-methods-use-this
	toggleChatBox() {
		new WinBox('Chat', {
			mount: document.querySelector('#chat-dev-tool'),
			index: 9999,
		}).resize('50%', '50%').move('center', 'center');
	}

	toggleLayoutDevtool() {
		if (this.layoutEditorWin) {
			this.layoutEditorWin.show();
			this.layoutEditorWin.minimize(false);
		}
		else {
			/** @type {WinboxType | undefined} */
			this.layoutEditorWin = new WinBox('Personnalisation de la page d\'accueil', {
				mount: document.querySelector('#home-layout-editor'),
				index: 9999,
				class: [
					'no-max',
					'no-full',
				],
				onclose: () => {
					this.$timeout(() => {
						this.HomeLayoutService.cancelSave();
						this.layoutEditorWin = undefined;
					});
					return false;
				},
			}).resize('860', '200').move('center', 'bottom');
		}
		this.HomeLayoutService.setEditMode(true);
	}

	showRecorder() {
		this.recorder.showUI(true);
	}

	$onInit() {
		this.#$rootScope.$on('$routeChangeSuccess', () => {
			if (!this.isActive('/') && this.layoutEditorWin) {
				this.layoutEditorWin.close();
			}
		});
	}
}
